import { mapGetters, mapActions, mapMutations } from 'vuex'
import track from './track'
import deliveryTime from './deliveryTime'
import unauthenticated from './unauthenticated'

export default {
  mixins: [track, deliveryTime, unauthenticated],
  data () {
    return {
      selectedTime: null,
      msg: ''
    }
  },
  computed: {
    ...mapGetters(['currentStore', 'cart', 'type', 'requestedTime']),
    logisticTypeOptions () {
      const options = [{ text: 'Collection', value: 'collection' }]
      if (this.storeInfo && this.storeInfo.delivery) {
        options.push({ text: 'Delivery', value: 'delivery' })
      }
      return options
    },
    proceedBtnDisabled () {
      if (!this.logisticType || !this.selectedTime || this.showTotalMaxLimit) {
        return true
      }
      if (this.logisticType === 'delivery' && !this.addressSelected) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions(['getCustomerAddresses', 'setCurrentStore', 'checkCartContent']),
    ...mapMutations(['setRequestedTime', 'setType', 'setStore']),
    async proceedToCheckout () {
      if (this.logisticType === 'delivery' && !this.addressSelected.store) {
        return this.showAlert('Sorry, we currently don\'t operate in ' + this.addressSelected.postcode, 'danger')
      }
      this.showLoading()
      const storeId = this.currentStore ? this.currentStore.id : null
      let newStore = storeId
      if (this.logisticType === 'delivery') {
        newStore = this.addressSelected.store.id
      }
      const response = await this.setCurrentStore({store_id: newStore })
      if (response.status === 'Error') {
        if (response.data.inactive) {
          this.setStore(null)
        }
        this.hideLoading()
        return this.showAlert(response.message, 'danger')
      }
      const { removedItems, removedItemsInDetail } = await this.checkCartContent()
      this.hideLoading()
      if (removedItems.length > 0) {
        this.msg = ""
        if (storeId !== this.currentStore.id) {
          this.msg += "You're switched to " + this.currentStore.name + " store based on your selected address.<br>"
        }
        this.msg += "We do not sell the following products (or deal configuration) at " + this.currentStore.name + ": <br>"
        this.msg += removedItems.map(item => item.name).join(', ') + "<br><br>"
        this.msg += "These products were removed automatically from your cart."
        if (this.$platform === 'app') {
          this.showAlert(this.msg, 'danger')
        } else {
          this.$bvModal.show('missing-product-modal')
        }
        this.$sentry.addBreadcrumb({
          category: 'error',
          message: 'Cart validation failed on frontend ' + Date.now(),
          level: 'info',
          data: { storeName: this.currentStore.name, removedItemsInDetail }
        })
        try { throw new Error('Cart validation failed on frontend ' + Date.now()) } catch (error) { this.$sentry.captureException(error) }
        return
      }
      this.trackCheckoutOption()  // Please confirm if this is about page visit, If so then it should be in mounted not here.
      this.setRequestedTime(this.selectedTime)
      this.redirectToCheckout()
    },
    updateSelectedTime (timeOptions) {
      if (timeOptions.length) {
        if (!this.selectedTime) {
          this.selectedTime = timeOptions[0].value
        } else {
          const timeExist = timeOptions.find(option => option.value === this.selectedTime)
          if (!timeExist) {
            this.selectedTime = timeOptions[0].value
          }
        }
      } else {
        this.selectedTime = null
      }
    },
    updateLogisticType () {
      if (this.storeInfo) {
        if (!this.storeInfo.delivery) {
          this.setType('collection')
        } else if (!this.type) {
          this.setType('delivery')
        }
        this.logisticType = this.type
      }
    }
  },
  watch: {
    selectedTime (newTime) {
      this.setRequestedTime(newTime)
    },
    type (type) {
      this.logisticType = type
    },
    timeOptions (newValue) {
      this.updateSelectedTime(newValue)
    }
  },
  mounted () {
    this.updateLogisticType()
    setTimeout(() => {
      this.selectedTime = this.requestedTime
      this.updateSelectedTime(this.timeOptions)
    }, 100)
  }
}
